import {
  RefreshKeyCloakUsersAndGroups,
  renderRefreshKeyCloakUsersAndGroupsButton,
} from './plugins/refresh-keycloak-users-and-groups';
import { RefreshLogs } from './plugins/refresh-logs-plugin/refresh-logs';
import { renderRefreshLogsButton } from './plugins/refresh-logs-plugin/render-refresh-logs-button';
import { renderSyncButton } from './plugins/sync-with-db/render-sync-button';
import { SyncWithDb } from './plugins/sync-with-db/sync-with-db';
import { PluginName } from './types';

export const PluginsRecord = {
  [PluginName.RefreshLogs]: {
    renderer: renderRefreshLogsButton,
    pluginController: RefreshLogs,
  },
  [PluginName.SyncWithDb]: {
    renderer: renderSyncButton,
    pluginController: SyncWithDb,
  },
  [PluginName.RefreshKeyCloakUsersAndGroups]: {
    renderer: renderRefreshKeyCloakUsersAndGroupsButton,
    pluginController: RefreshKeyCloakUsersAndGroups,
  },
} as const;
